import React, { FC, Suspense } from 'react'
import { useLoaderData } from 'react-router'
import Loader from '../../components/loader/Loader'
import { Await } from 'react-router-dom'
import Custom404 from '../../components/404/404'
import { OffreModel } from './types/OffreModel'
import Offre from './Offre'

interface DataType {
	offre: OffreModel
}

const DetailsOffre: FC = () => {
	const data: DataType = useLoaderData() as DataType

	return (
		<Suspense fallback={<Loader />}>
			<Await
				resolve={data.offre}
				errorElement={<Custom404 />}
			>
				{(offre) => (
					<Offre offre={offre} />
				)}
			</Await>
		</Suspense>
	)
}

export default DetailsOffre